import SessionTime from './SessionTime';

export { default as SessionTimeRedesign } from './SessionTime.redesign';
export default SessionTime;
